import { styled } from '@mui/material/styles';

export const FadeInWrapperStyled = styled('div', {
  shouldForwardProp: (prop) => prop !== 'isVisible',
})<{ isVisible: boolean }>`
  display: inherit;
  flex-direction: inherit;
  flex-wrap: inherit;
  height: inherit;
  opacity: ${({ isVisible }) => (isVisible ? 1 : 0)};
  transition: opacity 0.5s ease-in-out;
`;
